import { ChamadoDelegatarioComponent } from './pages/chamado-delegatario/chamado-delegatario.component';

import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ConsultarChamadoComponent } from "./pages/consultar-chamado/consultar-chamado.component";

//import { AuthGuard } from "./auth/_guards";
import { CadastroCartaPrecatoria } from './pages/cadastro-distribuidor/cadastro-carta-precatoria';
import { ChamadoAdvogadoComponent } from "./pages/chamado-advogado/chamado-advogado.component";
//import { T } from "@angular/core/src/render3";

const routes: Routes = [
  //Padrão para telas com base no perfil
  //{ path: 'home', component: HomeComponent, canActivate: [AuthGuard] },
  { path: "consultar-chamado", component: ConsultarChamadoComponent },
  { path: "chamado-advogado", component: ChamadoAdvogadoComponent },
  { path: "chamado-delegatario", component: ChamadoDelegatarioComponent },
  { path: "cadastro-carta-precatoria", component: CadastroCartaPrecatoria },
  //{ path: "cadastro-carta-precatoria", component: PageErrorComponent },
  
  //{ path: '',  component: MainComponent },
  { path: "**", redirectTo: "" }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes)],
  providers: []
})

export class AppRoutingModule {}
